var _rect, _path, _path2, _rect2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCtoConverterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    fill: "#3A4B59"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2905 30.8746C16.5288 27.5276 17.8257 24.334 20.0055 21.7688C22.4283 18.9176 25.7829 17.03 29.465 16.4438C33.147 15.8577 36.9167 16.6111 40.0963 18.5695C43.2761 20.528 45.6577 23.5635 46.8111 27.1312L49.1898 26.3622C47.8542 22.2307 45.0952 18.7122 41.4074 16.4408C37.7194 14.1693 33.3452 13.2946 29.0719 13.9749C24.7987 14.6551 20.9085 16.8454 18.1004 20.15C15.5747 23.1222 14.0733 26.8205 13.7969 30.6948L12.1592 30.5768L14.8638 33.6152L17.9764 30.9962L16.2905 30.8746Z",
    fill: "#00AEEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0223 33.1601L49.2004 30.6211L51.8269 33.7273L50.1829 33.5667C49.859 37.3459 48.3688 40.945 45.9 43.8504C43.0919 47.1549 39.2017 49.3452 34.9285 50.0255C30.6552 50.7057 26.281 49.831 22.593 47.5595C18.9052 45.2881 16.1462 41.7696 14.8105 37.6381L17.1893 36.8691C18.3427 40.4369 20.7243 43.4724 23.9041 45.4309C27.0837 47.3893 30.8534 48.1427 34.5354 47.5565C38.2175 46.9704 41.572 45.0828 43.9949 42.2315C46.1317 39.7169 47.4201 36.5984 47.6946 33.3235L46.0223 33.1601Z",
    fill: "#00AEEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2588,
    y: 29.2812,
    width: 10.4825,
    height: 10.4386,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.249 26.7793V24.2812H39.7409V34.7208H37.2435V26.7793H29.249Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtoConverterLogo);
export default __webpack_public_path__ + "static/media/cto-converter-logo.daccd128b55e039432da9b10cd2a3fe9.svg";
export { ForwardRef as ReactComponent };